import { TimeFilterProps } from 'hooks/useDateTimeFilter';
import { IntegrationEvents } from 'models/integrationEvents';
import { Pagination } from 'models/Pagination';

export enum LogLevelFilterTypes {
  CHANGE_DATETIME_FILTER = '[Log Filter] Change Date time filter',
  CHANGE_LOGLEVEL_FILTER = '[Log Filter] Change log level filter',
  CHANGE_PROVIDER_FILTER = '[Log Filter] Change provider filter',
  CHANGE_PAGE_FILTER = '[Log Filter] Change page filter',
  SEARCH_LOGS = '[Log] Logs search',
  SEARCH_LOGS_SUCCESS = '[Log] Logs search Success',
  SEARCH_LOGS_ERROR = '[Log] Logs search Error',
}

type IChangeDatetimeFilter = {
  type: typeof LogLevelFilterTypes.CHANGE_DATETIME_FILTER;
  payload: { data: TimeFilterProps };
};
type IChangeLogLevelFilter = {
  type: typeof LogLevelFilterTypes.CHANGE_LOGLEVEL_FILTER;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any };
};
type IChangeProviderFilter = {
  type: typeof LogLevelFilterTypes.CHANGE_PROVIDER_FILTER;
  payload: { data: string };
};
type IChangePageFilter = {
  type: typeof LogLevelFilterTypes.CHANGE_PAGE_FILTER;
  payload: { data: number };
};
type ISearchLogs = {
  type: typeof LogLevelFilterTypes.SEARCH_LOGS;
};
type ISearchLogsSuccess = {
  type: typeof LogLevelFilterTypes.SEARCH_LOGS_SUCCESS;
  payload: { data: IntegrationEvents[]; pagination: Pagination };
};
type ISearchLogsError = {
  type: typeof LogLevelFilterTypes.SEARCH_LOGS_ERROR;
  payload: { data: string };
};

export type LogLevelFilterActionTypes =
  | IChangeDatetimeFilter
  | IChangeLogLevelFilter
  | IChangeProviderFilter
  | IChangePageFilter
  | ISearchLogs
  | ISearchLogsSuccess
  | ISearchLogsError;

export const LogLevelFilterActionsCreatorsTypes = {
  changeDatetimeFilter: (data: TimeFilterProps): IChangeDatetimeFilter => ({
    type: LogLevelFilterTypes.CHANGE_DATETIME_FILTER,
    payload: { data },
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changeLogLevelFilter: (data: any): IChangeLogLevelFilter => ({
    type: LogLevelFilterTypes.CHANGE_LOGLEVEL_FILTER,
    payload: { data },
  }),
  changeProviderFilter: (data: string): IChangeProviderFilter => ({
    type: LogLevelFilterTypes.CHANGE_PROVIDER_FILTER,
    payload: { data },
  }),
  changePageFilter: (data: number): IChangePageFilter => ({
    type: LogLevelFilterTypes.CHANGE_PAGE_FILTER,
    payload: { data },
  }),
  searchLogs: (): ISearchLogs => ({
    type: LogLevelFilterTypes.SEARCH_LOGS,
  }),
  searchLogsSuccess: (
    data: IntegrationEvents[],
    pagination: Pagination,
  ): ISearchLogsSuccess => ({
    type: LogLevelFilterTypes.SEARCH_LOGS_SUCCESS,
    payload: { data, pagination },
  }),
  searchLogsError: (data: string): ISearchLogsError => ({
    type: LogLevelFilterTypes.SEARCH_LOGS_ERROR,
    payload: { data },
  }),
};
